import React, { Component } from 'react';
import Header from '../Header';
import { Loading } from '../Animations';
import AuthModal from '../Modal/AuthModal';
import ResourcesHeader from './ResourcesHeader';
import ResourceItem from './ResourceItem';
import FooterNav from '../FooterNav';
import { withAuthentication } from '../Session';

const ResourcesPage = () => (
	<div className="wrapper">
		<Header />
		<ResourcesContainer />
		<FooterNav />
	</div>
)

const INITIAL_STATE = {
	links: [],
	loading: true,
	isOpen: false,
	activeView: 'new'
};

class ResourcesContainerBase extends Component {
	state = { ...INITIAL_STATE };

	componentDidMount() {
		document.title = "leveler: resources"
		this.getNewLinks(true);
	}

	newLinksClicked = () => {
		const { logEvent } = this.props.firebase;
		logEvent("new_resources_clicked");
	}

	getNewLinks = async (loading) => {

		this.setState({
			loading: loading
		})
		// LOG GA EVENT
		this.newLinksClicked();

		let links = [];
		const { resourcesCollection } = this.props.firebase;
		try {
			await resourcesCollection
				.where("type", "==", "story")
				.orderBy("created", "desc")
				.limit(50)
				.get()
				.then((querySnapshot) => {
					querySnapshot.forEach((doc) => {
						let link = doc.data();
						// SET UP ID
						link.id = doc.id;
						// SET UP PATH
						link.path = doc.ref.path;
						// PUSH TO STATE
						links.push(link)
					})
				})
				if (links) {
					this.setState({
						links,
						loading: false
					})
				}
		} catch(e) {
			console.log(e.message)
		}
	}

	render() {
		const { isOpen } = this.state;
		const {
			firebase,
			userData,
		 } = this.props;
		const {
			doSignOut,
			logEvent,
			resourcesCollection,
		} = firebase;

		const getByCategory = async (category) => {
			this.setState({
				loading: true
			})
			// GA EVENT
			logEvent("resource_category_clicked", {category: category});
			let links = [];
			try {
				await resourcesCollection
					.where("type", "==", "story")
					.where("category", "==", category)
					.limit(30)
					.get()
					.then((querySnapshot) => {
						querySnapshot.forEach((doc) => {
							let link = doc.data();
							// SET UP ID
							link.id = doc.id;
							// SET UP PATH
							link.path = doc.ref.path;
							// PUSH TO STATE
							links.push(link)
						})
					})
					if (links) {
						this.setState({
							links,
							loading: false
						})
					}
				} catch(e) {
					console.log(e.message)
				}
		}

		const logout = () => {
			doSignOut()
		}

		// MODAL STATE MANAGEMENT
		const toggleModal = (isOpen) => {
			this.setState({
				isOpen: !isOpen
			})
		}

		return (
			<>
				<AuthModal
					toggleModal={toggleModal}
					isOpen={isOpen}
					firebase={firebase}
				/>

				<ResourcesHeader
					userData={userData}
					toggleModal={toggleModal}
					logout={logout}
				/>
				<div className="resources-body">
					{this.state.loading && <Loading height="70" width="70"/>}

					{!this.state.loading ? (
						this.state.links.map((item) =>
							<ResourceItem
								key={item.id}
								item={item}
								getByCategory={getByCategory}
								userData={userData}
							/>
						)
					): null}
				</div>
			</>
		)
	}
}

const ResourcesContainer = withAuthentication(ResourcesContainerBase);

export default ResourcesPage;

export { ResourcesContainer };
